import React from "react";
import {Grid} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import WizardFilterItem from "./wizardFilterItem";

const WizardMobileGrid = (props) => {

  const {selectionWindowView, filterGroupValues, filterGroup, listItemHeight} = props;
  const columnWidth = selectionWindowView === 1 ? listItemHeight - 14 : (listItemHeight - 6)/2;

  const elements = [];
  for (let i = 0; i < filterGroupValues.length; i++ ) {
    elements.push(<WizardFilterItem currentFilterValue={filterGroupValues[i]}
                                    listItemHeight={listItemHeight}
                                    filterGroup={filterGroup}/>);
  }
  const container = document.querySelector(".selection-main__bv-item");
  const minColumns = container && Math.ceil(container.clientWidth / columnWidth) - 1;
  if (minColumns && (selectionWindowView === 2) && (elements.length < minColumns)) {
    for (let i = 1; i <= minColumns - elements.length;i++) {
      elements.push(<div className="feature feature--empty"/>);
      elements.push(<div className="feature feature--empty"/>);
    }
  }

  const menuBody = document.querySelector(".bv-item-container");
  const navigationViewType = selectionWindowView === 3 ? 2 : selectionWindowView; // 2
  const columnsCount = Math.ceil(elements.length / navigationViewType); // for ex. 28/3 = 10 columns

  const list = [[]];  // making list for React Virtualized
  if (navigationViewType === 2) {
    list.push([]);
    elements.forEach((element, index) => {
      let rowIndex = (index % navigationViewType === 0) ? 0 : 1;
      list[rowIndex].push(React.cloneElement(element))
    });
  } else {
    elements.forEach((element) => list[0].push(React.cloneElement(element)));
  }

  return (
    <Grid rowCount={navigationViewType}
          columnCount={columnsCount}
          width={menuBody.clientWidth}
          height={(columnWidth * navigationViewType) - 1}
          columnWidth={columnWidth}
          rowHeight={columnWidth}
          cellRenderer={({columnIndex, key, rowIndex, style}) => {
            return <div key={key} style={style}>
              {list[rowIndex][columnIndex]}
            </div>
          }}>
    </Grid>
  )

}

WizardMobileGrid.propTypes = {
  currentParent: PropTypes.object.isRequired,
  filterGroupValues: PropTypes.array.isRequired,
  filterGroup: PropTypes.object.isRequired,
  currentActiveFilters: PropTypes.object.isRequired,
  listItemHeight: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  return {
    selectionWindowView,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WizardMobileGrid)
